import { render, staticRenderFns } from "./withdrawalList.vue?vue&type=template&id=2734b50f&scoped=true&"
import script from "./withdrawalList.vue?vue&type=script&lang=js&"
export * from "./withdrawalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2734b50f",
  null
  
)

export default component.exports